import React from 'react'
import './DateArea.scss'
import {Grid, Box} from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import ErrorIcon from '@material-ui/icons/ErrorOutline'
import _ from 'lodash'

export default function PreviousInfoDesign({
  state,
  status,
  approveClick,
  rejectClick,
  hasApprovalManager,
}) {
  return (
    <>
      {
        <div style={{fontSize: '14px', textTransform: 'capitalize'}}>
          {hasApprovalManager &&
            state !== 'rejected' &&
            state !== 'no_response' &&
            status !== 'cancelled' && (
              <div style={{display: '-webkit-inline-box', marginTop: '10px'}}>
                <CheckIcon
                  style={{
                    width: '15px',
                    height: '15px',
                    borderRadius: '50%',
                    border: '1px solid #3473ff',
                    color: 'white',
                    backgroundColor: '#3473ff',
                    marginRight: '8px',
                  }}
                />
                Requested&nbsp;
                <Box color="#1d2331">- Approved</Box>
              </div>
            )}
          {hasApprovalManager && state === 'rejected' && (
            <div style={{display: '-webkit-inline-box', marginTop: '10px'}}>
              <ClearIcon
                style={{
                  width: '15px',
                  height: '15px',
                  borderRadius: '50%',
                  border: '1px solid #ff2020',
                  color: 'white',
                  backgroundColor: '#ff2020',
                  marginRight: '8px',
                }}
              />
              Requested&nbsp;
              <Box color="#1d2331">- Rejected</Box>
            </div>
          )}
          {status === 'cancelled' && (
            <div style={{display: '-webkit-inline-box', marginTop: '10px'}}>
              <ClearIcon
                style={{
                  width: '15px',
                  height: '15px',
                  borderRadius: '50%',
                  border: '1px solid #ff2020',
                  color: 'white',
                  backgroundColor: '#ff2020',
                  marginRight: '8px',
                }}
              />
              Cancelled
            </div>
          )}

          {hasApprovalManager && state === 'no_response' && (
            <div style={{display: '-webkit-inline-box', marginTop: '10px'}}>
              <ErrorIcon
                style={{
                  width: '15px',
                  height: '15px',
                  borderRadius: '50%',
                  border: '0px solid #edc43e',
                  color: 'white',
                  backgroundColor: '#edc43e',
                  marginRight: '8px',
                }}
              />
              Requested&nbsp;
              <Box color="#1d2331">- No Response</Box>
            </div>
          )}
        </div>
      }
      <div hidden={status === 'cancelled'}>
        {hasApprovalManager && (
          <div
            className="reservation-bookings-info-area__vertical-line"
            style={{
              borderLeft:
                state === 'rejected' || state === 'no_response' ? '' : '2px solid #3473ff',
            }}
          />
        )}
        {state !== 'rejected' &&
          state !== 'no_response' &&
          state !== 'abandoned' &&
          status !== 'fulfilled' && (
            <div style={{fontSize: '14px', textTransform: 'capitalize'}}>
              <div style={{display: '-webkit-inline-box', marginTop: '2px'}}>
                <CheckIcon
                  style={{
                    width: '15px',
                    height: '15px',
                    borderRadius: '50%',
                    border: '1px solid #3473ff',
                    color: 'white',
                    backgroundColor: '#3473ff',
                    marginRight: '8px',
                  }}
                />
                Upcoming&nbsp;
                <Box color="#1d2331">- Outstanding</Box>
              </div>
            </div>
          )}
        {status === 'fulfilled' && (
          <div style={{fontSize: '14px', textTransform: 'capitalize'}}>
            <div style={{display: '-webkit-inline-box', marginTop: '2px', color: '#acb0ba'}}>
              <CheckIcon
                style={{
                  width: '15px',
                  height: '15px',
                  borderRadius: '50%',
                  border: '1px solid #3473ff',
                  color: 'white',
                  backgroundColor: '#3473ff',
                  marginRight: '8px',
                }}
              />
              <Box color="#1d2331">Upcoming</Box>
            </div>
          </div>
        )}
        {(state === 'rejected' || state === 'no_response') && (
          <div style={{fontSize: '14px', textTransform: 'capitalize'}}>
            <div style={{display: '-webkit-inline-box', marginTop: '2px', color: '#acb0ba'}}>
              <div
                className="reservation-bookings-info-area__outer-circle"
                style={{border: '8px solid #eaebee'}}
              />
              <Box color="#acb0ba">Upcoming</Box>
            </div>
          </div>
        )}
        {state === 'abandoned' && (
          <div style={{fontSize: '14px', textTransform: 'capitalize'}}>
            <div style={{display: '-webkit-inline-box'}}>
              <ErrorIcon
                style={{
                  width: '15px',
                  height: '15px',
                  borderRadius: '50%',
                  border: '0px solid #edc43e',
                  color: 'white',
                  backgroundColor: '#edc43e',
                  marginRight: '8px',
                }}
              />
              Upcoming&nbsp;
              <Box color="#1d2331">- Abandoned</Box>
            </div>
          </div>
        )}
        <div
          className="reservation-bookings-info-area__vertical-line"
          style={{
            borderLeft:
              state === 'rejected' || state === 'no_response' || state === 'abandoned'
                ? ''
                : '2px solid #3473ff',
          }}
        />
        {state !== 'rejected' && state !== 'no_response' && state !== 'abandoned' && (
          <div style={{fontSize: '14px', textTransform: 'capitalize', marginBottom: '34px'}}>
            <div style={{display: '-webkit-inline-box', marginTop: '2px'}}>
              <CheckIcon
                style={{
                  width: '15px',
                  height: '15px',
                  borderRadius: '50%',
                  border: '1px solid #3473ff',
                  color: 'white',
                  backgroundColor: '#3473ff',
                  marginRight: '8px',
                }}
              />
              Fulfilled&nbsp;
              <Box color="#1d2331">- Returned</Box>
            </div>
          </div>
        )}
        {(state === 'rejected' || state === 'no_response' || state === 'abandoned') && (
          <div style={{fontSize: '14px', textTransform: 'capitalize', marginBottom: '34px'}}>
            <div style={{display: '-webkit-inline-box', marginTop: '2px', color: '#acb0ba'}}>
              <div
                className="reservation-bookings-info-area__outer-circle"
                style={{border: '8px solid #eaebee'}}
              />
              Fulfilled
            </div>
          </div>
        )}
      </div>
    </>
  )
}
